import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
// eslint-disable-next-line import/no-extraneous-dependencies
import qs from 'query-string';

export const useLocationSearch = () => {
  const location = useLocation();
  const querParams = useMemo(() => {
    const search = qs.parse(location.search);
    // By spreading it out we avoid a bug in current shared-ui's version of hasValue checks
    // which crashes due to error: " Cannot convert object to primitive value"
    // But by spreadking out query params it avoids the error
    return { ...search };
  }, [location.search]);

  // Return memoized query params to prevent re-renders when used in other hooks
  return querParams;
};

export const useLocationSearchParam = (key) => {
  const queryParams = useLocationSearch();
  return queryParams[key];
};
